import AccessibilityWidget, {
  openAccessibilityMenu
} from './UserWayAccessibilityWidget'

export default AccessibilityWidget
export { openAccessibilityMenu }
